import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import InputCard from "./components/InputCard";
import ButtonContainer from "./components/ButtonContainer";

function App() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [name, setName] = useState({ value: "", err: false, errTxt: "" });
  const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
  const [phone, setPhone] = useState({ value: "", err: false, errTxt: "" });
  const [amount, setAmount] = useState({ value: "", err: false, errTxt: "" });
  const [clicked, setClicked] = useState(false);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleData = (value, field) => {
    if (field === "name") setName({ value, err: false, errTxt: "" });
    else if (field === "phone") setPhone({ value, err: false, errTxt: "" });
    else if (field === "email") setEmail({ value, err: false, errTxt: "" });
    else if (field === "amount") setAmount({ value, err: false, errTxt: "" });
    else console.log("All good");
  };

  const validateEmail = (email) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
  };

  const pay = async () => {
    setClicked(true);

    const nameRegEx = /^[A-Za-z ]+$/;
    const numRegEx = new RegExp("^[0-9]*$");
    const amountRegEx = new RegExp("^[0-9.]*$");

    if (name.value === "") {
      setName({ value: "", err: true, errTxt: "Name cannot be empty" });
      setClicked(false);
      return;
    }

    if (phone.value === "") {
      setPhone({
        value: "",
        err: true,
        errTxt: "Phone Number cannot be empty",
      });
      setClicked(false);
      return;
    }

    if (email.value === "") {
      setEmail({
        value: "",
        err: true,
        errTxt: "Email cannot be empty",
      });
      setClicked(false);
      return;
    }

    if (amount.value === "") {
      setAmount({ value: "", err: true, errTxt: "Amount cannot be empty" });
      setClicked(false);
      return;
    }

    if (!nameRegEx.test(name.value)) {
      setName({ value: "", err: true, errTxt: "Only English Letters" });
      setClicked(false);
      return;
    }

    if (!numRegEx.test(phone.value)) {
      setPhone({
        value: "",
        err: true,
        errTxt: "Invalid Phone Number",
      });
      setClicked(false);
      return;
    }

    if (!validateEmail(email.value)) {
      setEmail({
        value: "",
        err: true,
        errTxt: "Invalid Email",
      });
      setClicked(false);
      return;
    }

    if (!amountRegEx.test(amount.value)) {
      setAmount({ value: "", err: true, errTxt: "Invalid Amount" });
      setClicked(false);
      return;
    }

    const expandedAmount = [...amount.value];
    const filterCheck = expandedAmount.filter(
      (item) =>
        item.charCodeAt(0) === 46 ||
        (item.charCodeAt(0) >= 48 && item.charCodeAt(0) <= 57)
    );

    if (filterCheck.length === amount.value.length) {
      const url =
        "https://juliette-sawyer.herokuapp.com/api/payment/generatePaymentRequest";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name.value,
          phone: phone.value,
          email: email.value,
          amount:
            amount.value.split(".").length === 1
              ? `${amount.value}.00`
              : amount.value,
        }),
      });
      const json = await response.json();

      window.location = json.payUrl;
    } else {
      alert("Invalid Amount");
      setClicked(false);
    }
  };

  const styles = {
    container: {
      backgroundColor: "#242424",
      width: "100%",
      height:
        windowDimensions.width <= 380
          ? "140vh"
          : windowDimensions.width <= 500
          ? "130vh"
          : windowDimensions.width > 500 && windowDimensions.width < 1000
          ? "120vh"
          : windowDimensions.width < 1500
          ? "170vh"
          : "165vh",
      margin: 0,
      display: "flex",
      overflow: "hidden",
      flex: 1,
      flexDirection: "column",
      minHeight: "100%",
    },
    whiteContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "5%",
      paddingBottom: "5%",
      height:
        windowDimensions.width <= 380
          ? "130vh"
          : windowDimensions.width <= 500
          ? "125vh"
          : windowDimensions.width > 500 && windowDimensions.width < 1000
          ? "125vh"
          : windowDimensions.width < 1500
          ? "150vh"
          : "155vh",
    },
    fontSizeStyle: {
      fontFamily: "Poppins",
      opacity: 0.5,
      fontSize:
        windowDimensions.width <= 380
          ? "0.75em"
          : windowDimensions.width <= 500
          ? "0.8em"
          : windowDimensions.width > 500 && windowDimensions.width < 600
          ? "1em"
          : windowDimensions.width >= 600 && windowDimensions.width < 1000
          ? "1em"
          : windowDimensions.width < 1500
          ? "1em"
          : "1em",
    },
    headerFontStyle: {
      fontFamily: "Poppins",
      fontSize:
        windowDimensions.width <= 380
          ? "1.2em"
          : windowDimensions.width <= 500
          ? "1.4em"
          : windowDimensions.width > 500 && windowDimensions.width < 600
          ? "1.4em"
          : windowDimensions.width >= 600 && windowDimensions.width < 1000
          ? "1.8em"
          : windowDimensions.width < 1500
          ? "1.9em"
          : "2em",
    },
    mobileButton: {
      width: "100%",
      padding: "5%",
      borderRadius: 10,
      fontStyle: "Poppins",
      fontSize: "1em",
      height: 40,
    },
    desktopButton: {
      width: "100%",
      padding: "2%",
      borderRadius: 10,
      fontStyle: "Poppins",
      fontSize: "1.2em",
      height: 20,
    },
    fieldsContainer: {
      marginLeft: "5%",
      marginRight: "5%",
    },
    titleContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    bodyContainer: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "transparent",
      borderRadius: 10,
      width: "90%",
      background: "white",
    },
    logoContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.whiteContainer}>
        <div style={styles.bodyContainer}>
          <div style={styles.logoContainer}>
            <img src={logo} style={{ height: windowDimensions.height / 4 }} />
          </div>
          {console.log(windowDimensions.width)}
          <div style={styles.fieldsContainer}>
            <div style={styles.titleContainer}>
              <h1 style={styles.headerFontStyle}>Juliette Sawyer PayMe</h1>
            </div>

            <InputCard
              label={"Full Name"}
              arabicLabel={"الاسم بالكامل"}
              handleData={handleData}
              err={name.err}
              errTxt={name.errTxt}
              disabled={false}
              fontStyle={styles.fontSizeStyle}
              property={"name"}
            />

            <InputCard
              label={"Phone"}
              arabicLabel={"رقم الجوال"}
              handleData={handleData}
              err={phone.err}
              errTxt={phone.errTxt}
              disabled={false}
              fontStyle={styles.fontSizeStyle}
              property={"phone"}
            />

            <InputCard
              label={"Email"}
              arabicLabel={"بريد الالكتروني"}
              handleData={handleData}
              err={email.err}
              errTxt={email.errTxt}
              disabled={false}
              fontStyle={styles.fontSizeStyle}
              property={"email"}
            />

            <InputCard
              label={"Amount"}
              arabicLabel={"المبلغ"}
              handleData={handleData}
              err={amount.err}
              errTxt={amount.errTxt}
              disabled={false}
              fontStyle={styles.fontSizeStyle}
              property={"amount"}
            />
          </div>

          <ButtonContainer
            windowDimensions={windowDimensions}
            clicked={clicked}
            pay={pay}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
